import { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import Select from "react-select";
import { optionSelector } from "../../config/apiSPA.js";

function ModalPlanTrainingParticipant({ show, onHide, submitClick, id }) {
  const [option, setOption] = useState([]);
  const [selected, setSelected] = useState("");
  const [remark, setRemark] = useState("");

  const getOption = () => {
    optionSelector("/manpower").then((res) => setOption(res));
  };

  function handleSubmit() {
    submitClick({ mainId: id, mpId: selected.value, remark });
  }

  return (
    <>
      <Modal
        show={show}
        onShow={() => getOption()}
        onHide={() => {
          onHide();
        }}
      >
        <ModalHeader closeButton>
          <h5 className="modal-title">New Participant</h5>
        </ModalHeader>
        <ModalBody>
          <div className="form-group mb-3">
            <label className="form-label" htmlFor="exampleFormControlInput1">
              Participant
            </label>
            <Select onChange={(e) => setSelected(e)} options={option} isSearchable classNamePrefix="react-select" />
          </div>
          <div className="form-group mb-3">
            <label className="form-label" htmlFor="exampleFormControlInput1">
              Remark
            </label>
            <textarea onChange={(e) => setRemark(e.target.value)} className="form-control" />
          </div>
          <div className="alert bg-inverse bg-opacity-15">Please select available participant</div>
        </ModalBody>
        <ModalFooter>
          <button type="button" onClick={() => handleSubmit()} className={selected ? "btn btn-outline-theme" : "btn btn-outline-theme disabled"}>
            Save changes
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ModalPlanTrainingParticipant;
